import type { FunctionComponent, HTMLAttributes, MouseEvent, ReactElement } from 'react';

import { useUITranslation } from '../../../services/uiTranslations/reactBindings/hooks';
import { useIsLegacyDesktop } from '../../../styles/hooks/legacyMedia';
import { useModifiers } from '../../../styles/hooks/useModifiers';
import { Icons } from '../../icons/iconNames';
import { useLegacyContext } from '../../legacyMode/LegacyContextProvider';
import { IconButton, IconButtonSize } from '../iconButton/IconButton';

import styles from './BackButton.module.css';

export interface BackButtonProps extends HTMLAttributes<HTMLButtonElement> {
  visible?: boolean;
}

export const BackButton: FunctionComponent<BackButtonProps> = ({
  className = '',
  onClick,
  visible = false,
}): ReactElement => {
  const backTitle = useUITranslation('BACK');
  const mods = useModifiers(styles, 'backButton', { visible }, { withBaseClass: true });
  const { isLegacyMode } = useLegacyContext();
  const isLegacyDesktop = useIsLegacyDesktop();
  const isSmallButton = isLegacyMode && isLegacyDesktop;

  return (
    <div data-testid="back-button" className={`${mods} ${className}`}>
      <IconButton
        ghost
        icon={Icons.ChevronLeft}
        onClick={(event) => onClick?.(event as MouseEvent<HTMLButtonElement>)}
        title={backTitle}
        size={isSmallButton ? IconButtonSize.SMALL : IconButtonSize.TINY}
      />
    </div>
  );
};
